export const QUERIES = {
	POSTS: 'posts',
	IMAGES: 'images',
	CATEGORIES: 'categories',
}
